export const valueFrom = (size) => {
    switch (size) {
        case 'small':
            return '16px';
        case 'large':
            return '32px';
        case 'medium':
        default:
            return '24px';
    }
};
